<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    await this.getCreditEvaluationsCurrent()
    // 언제부터 빠져있던것인가?
    // if (Object.keys(data).length === 0) {
    //   const path = '/factoring/confirm'
    //   if (
    //     this.$route.path !== path &&
    //     this.$route.path !== '/factoring/evaluation' &&
    //     this.routerStatusRedirect
    //   ) {
    //     await this.$router.replace(path)
    //   }
    //   return
    // }
    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('evaluation', ['getCreditEvaluationsCurrent']),
  },
}
</script>
